import React, { FC, useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import SummaryTableComponent from '@features/common/components/SummaryTableComponent/SummaryTableComponent';
import SummaryTableRowComponent from '@features/common/components/SummaryTableRowComponent/SummaryTableRowComponent';
import DateComponent from '@features/common/components/DateComponent/DateComponent';
import styles from './GeneralTabComponent.module.scss';

interface BuildInfo {
    version: string;
    buildTimestamp: string | null;
}

const GeneralTabComponent: FC = () => {
    const [buildInfo, setBuildInfo] = useState<BuildInfo | null>(null);

    useEffect(() => {
        fetch('/info')
            .then((res) => res.json())
            .then((data: BuildInfo) => setBuildInfo(data))
            .catch(() => setBuildInfo({ version: 'unknown', buildTimestamp: null }));
    }, []);

    return (
        <div className={styles.GeneralTabComponent} data-testid="GeneralTabComponent">
            <Typography variant="body2" sx={{ mb: 2 }}>Do not adjust settings unless requested by Bodd Support</Typography>
            {buildInfo && (
                <SummaryTableComponent>
                    <SummaryTableRowComponent label="Version" value={buildInfo.version} />
                    <SummaryTableRowComponent
                        label="Build timestamp"
                        value={
                            buildInfo.buildTimestamp
                                ? <DateComponent date={buildInfo.buildTimestamp} showFull /> : 'unknown'
                        }
                    />
                </SummaryTableComponent>
            )}
        </div>
    );
};

export default GeneralTabComponent;
